import React from 'react';
import classNames from 'classnames';
import { formatAverage, ratingTone, SURVEY_RATING_MAX, toPercentages } from '../surveyUtils';

interface Props {
  average: number | null;
  ratingCount: number;
  distribution: number[] | undefined;
}

const RATING_VALUES = Array.from({ length: SURVEY_RATING_MAX }, (_, index) => index + 1);

export function RatingSummary({ average, ratingCount, distribution }: Props): React.ReactElement {
  const counts = RATING_VALUES.map((value) => distribution?.[value - 1] ?? 0);
  const percentages = toPercentages(counts);
  const maxCount = Math.max(...counts, 1);

  return (
    <section className='survey-results-card survey-rating-summary' aria-label='Valoración'>
      <div className='survey-rating-summary-score'>
        <span className='survey-results-card-label'>Valoración media</span>
        <span className={classNames('survey-rating-summary-value', average !== null && `tone-${ratingTone(average)}`)}>
          {formatAverage(average)}
          <small>{`/ ${SURVEY_RATING_MAX}`}</small>
        </span>
        <span className='survey-results-card-hint'>{ratingCount === 1 ? '1 valoración' : `${ratingCount} valoraciones`}</span>
      </div>

      {distribution && (
        <div className='survey-rating-summary-chart'>
          <ol className='survey-rating-bars' aria-label='Distribución de valoraciones'>
            {RATING_VALUES.map((value, index) => (
              <li key={value} aria-label={`${value}: ${counts[index]} (${percentages[index]} %)`}>
                <span className='survey-rating-bar-count'>{counts[index] > 0 ? counts[index] : ''}</span>
                <span className='survey-rating-bar-track'>
                  <span
                    className={classNames('survey-rating-bar', `tone-${ratingTone(value)}`)}
                    style={{ height: `${(counts[index] / maxCount) * 100}%` }}
                    title={`${counts[index]} (${percentages[index]} %)`}
                  />
                </span>
                <span className='survey-rating-bar-label'>{value}</span>
              </li>
            ))}
          </ol>
        </div>
      )}
    </section>
  );
}
